/** @format */

// themes.js
export const darkTheme = {
  themeName: 'dark',
  mainTitleColor: '#212121',

  mainDescriptionColor: '#6e6e6e',
  background: '#ffffff',
  mainPageBg: '#ffffff',
  sidebarBackground: '#1A1C3B',
  sidebarGroupBackground: '#292B4BFF',
  sidebarGroupTextColor: 'rgba(255, 255, 255, 0.6)',
  sidebarTextColor: '#fff',
  sidebarItemActive: 'rgba(242, 248, 253, 0.1)',
  sidebarItemHover: 'rgba(242, 248, 253, 0.1)',
  sidebarItemActiveBlur: 'blur(18px)',
  formBackground: '#ffffff',
  primaryButtonBackground: '#1A1C3B',
  primaryButtonText: '#fff',
  primaryButtonLightBackground: 'rgba(26, 28, 59, 0.3)',
  primaryButtonLightText: 'rgba(26, 28, 59, 1)',
  primaryButtonTextHover: '#fff',
  primaryButtonBorder: '#1A1C3B',
  primaryDisabledTextColor: '#c4c4c4',
  primaryInputBorder: '#eeeeee',
  primaryInputBorderHover: '#1A1C3B',
  primaryBorderColor: '#1A1C3B',
  primaryInputBorderFocus: '#1A1C3B',
  segmentedBackground: '#3c4183',
  segmentedActiveText: '#fff',

  subHeaderBackground: '#F3F3F3',

  secondaryButtonBackground: '#ffffff',
  secondaryButtonText: '#212121',
  secondaryButtonHoverBackground: 'rgba(242, 248, 253, 0.1)',
  secondaryButtonTextHover: '#212121',
  primaryButtonHoverBackground: '#212121',
  secondaryButtonBorder: '#1A1C3B',

  cancelButtonBackground: '#ffffff',
  cancelButtonText: '#F50C0CFF',
  cancelButtonHoverBackground: 'rgba(242, 248, 253, 0.1)',
  cancelButtonTextHover: '#212121',
  cancelButtonBorder: '#1A1C3B',

  contentMainTitleColor: '#212121',
  contentMainDescriptionColor: '#000000',

  linkTitleColor: '#0078D4',

  tableLabelColor: '#6E6E6E',
  tableValueColor: '#212121',

  formHeaderTitleColor: '#212121',
  formHeaderSubtitleColor: '#212121',
  mainIconColor: '#212121',

  pageHeaderBackground: '#F3F3F3',
  pageHeaderTitleColor: '#004578',
  pageHeaderTitleFontSize: '28px',
  pageHeaderTitleFontWeight: '700',
  pageHeaderTitleLineHeight: 'normal',
  pageHeaderTitleFontFamily: 'Roboto',
  pageHeaderSubtitleColor: '#212121',
  pageHeaderSubtitleFontSize: '14px',
  pageHeaderSubtitleFontWeight: '400',
  pageHeaderSubtitleLineHeight: 'normal',
  pageHeaderSubtitleFontFamily: 'Roboto',
  pageHeaderSubtitleFontStyle: 'normal',

  scrollBarThumb: '#1A1C3B',
  scrollBarBackground: 'rgba(242, 248, 253, 0.2)',
  mainPageActiveShortcutButtonBackground: '#ffffff',
  mainPageActiveShortcutButtonText: '#212121',
  mainPageInactiveShortcutButtonBackground: 'rgba(255, 255, 255, 0.10)',
  mainPageInactiveShortcutButtonText: '#b4b4b4',
  warehouseCardBackgroundHover: '#F2F8FD',
  warehouseCardBorderHover: '1px solid rgba(0, 120, 212, 0.10)',
  warehouseCardBackground: '#FFFFFF',
  warehouseCardBorder: '1px solid #eeeeee',

  tabContainerBackground: '#1A1C3B',
  tabBackground: 'rgba(255, 255, 255, 0.1)',
  tabText: '#ffffff',
  tabIcon: '#ffffff',
  tabSelectedBackground: '#ffffff',
  tabIconSelected: '#1A1C3B',
  tabSelectedText: '#1A1C3B',

  defaultIconColor: 'rgba(33, 33, 33, 1)',
  warningIconColor: 'rgba(228, 156, 0, 1)',
  successIconColor: 'rgba(33, 163, 102, 1)',
  infoIconColor: 'rgba(0, 120, 212, 1)',
  errorIconColor: 'rgba(255, 0, 0, 1)',
  secondaryIconColor: 'rgba(153, 153, 153, 1)',

  defaultTextColor: 'rgba(33, 33, 33, 1)',
  warningTextColor: 'rgba(228, 156, 0, 1)',
  successTextColor: 'rgba(33, 163, 102, 1)',
  infoTextColor: 'rgba(0, 120, 212, 1)',
  errorTextColor: 'rgba(255, 0, 0, 1)',
  secondaryTextColor: 'rgba(153, 153, 153, 1)',

  // Semantic surface tokens (intro: transport-nakladnoy 2026-06, see
  // docs/migrations/005-transport-nakladnoy-ui-migration.md D-1). Previously
  // static-only in theme-variables.css — bridged here so theme switching owns them.
  surfaceStrong: '#0e1a2c',
  surfaceSoft: '#f6f7fb',
  surfaceSofter: '#fafbfd',
  textOnSurface: '#0f172a',
  textMuted: '#6b7280',
  borderSubtle: '#e4e7ee',
  borderStrong: '#cdd3df',
  accentLink: '#1976e2',
  statePositive: '#14a45b',
  stateWarning: '#ef8a17',
  stateCritical: '#e53935',
  stateInfo: '#2272d6',
  textOnSurfaceSecondary: '#334155',
  textMutedSoft: '#94a3b8',
  surfaceMuted: '#f8fafc',

  // Status tint backgrounds (badge/chip fills derived from the status palette)
  warningTint: '#e49c0026',
  successTint: '#21a36626',
  infoTint: '#0078d426',
  primaryTint: '#1a1c3b0a',

  // Accounting category identity palette (src/features/accounting taxonomy).
  // Data-identity colors: intentionally identical in both themes so charts,
  // chips and swatches keep meaning across theme switches — centralized here
  // per the "all colors live in theme.ts" mandate (2026-06-11).
  categoryIncomeProduction: '#1b8a4d',
  categoryIncomeProductionTint: '#1b8a4d1a',
  categoryIncomeService: '#2272d6',
  categoryIncomeServiceTint: '#2272d61a',
  categoryIncomeOther: '#9b6bd1',
  categoryIncomeOtherTint: '#9b6bd11a',
  categoryIncomeLoan: '#d9a635',
  categoryIncomeLoanTint: '#d9a6351a',
  categoryExpenseMaterial: '#d9533a',
  categoryExpenseMaterialTint: '#d9533a1a',
  categoryExpenseTransport: '#ef8a17',
  categoryExpenseTransportTint: '#ef8a171a',
  categoryExpenseSalary: '#b85ec7',
  categoryExpenseSalaryTint: '#b85ec71a',
  categoryExpenseUtility: '#1f7ad1',
  categoryExpenseUtilityTint: '#1f7ad11a',
  categoryExpenseRent: '#5a6b88',
  categoryExpenseRentTint: '#5a6b881a',
  categoryExpenseTax: '#0e1a2c',
  categoryExpenseTaxTint: '#0e1a2c1a',
  categoryExpenseOther: '#94a3b8',
  categoryExpenseOtherTint: '#94a3b81a',
}

export const classicTheme = {
  themeName: 'classic',
  mainTitleColor: '#212121',
  mainDescriptionColor: '#6e6e6e',
  background: '#ffffff',
  mainPageBg: '#ffffff',
  sidebarBackground: '#1890FF',
  sidebarGroupBackground: '#3DA0FFFF',
  sidebarGroupTextColor: 'rgba(255, 255, 255, 0.6)',
  sidebarTextColor: '#fff',
  sidebarItemActive: 'rgba(0, 120, 212, 0.1)',
  sidebarItemHover: 'rgba(0, 120, 212, 0.1)',
  sidebarItemActiveBlur: 'blur(18px)',
  primaryDisabledTextColor: '#c4c4c4',

  primaryButtonBackground: '#1890FF',
  primaryButtonLightBackground: 'rgba(0, 0, 0, 0.5)',
  primaryButtonLightText: 'rgba(24, 144, 255, 1)',
  formBackground: '#ffffff',
  primaryButtonText: '#fff',
  primaryButtonHoverBackground: 'rgba(0, 120, 212, 0.1)',
  primaryButtonTextHover: '#fff',
  primaryButtonBorder: '#1890FF',

  primaryInputBorder: '#eeeeee',
  primaryInputBorderHover: '#1890FF',
  primaryInputBorderFocus: '#1890FF',
  primaryBorderColor: '#1890FF',
  segmentedBackground: '#46A6FF',
  segmentedActiveText: '#fff',

  subHeaderBackground: '#F3F3F3',

  secondaryButtonBackground: '#ffffff',
  secondaryButtonText: '#212121',
  secondaryButtonHoverBackground: '#1890FF',
  secondaryButtonTextHover: '#ffffff',
  secondaryButtonBorder: '#1890FF',

  cancelButtonBackground: '#ffffff',
  cancelButtonText: '#F50C0CFF',
  cancelButtonHoverBackground: 'rgba(0, 120, 212, 0.1)',
  cancelButtonTextHover: '#212121',
  cancelButtonBorder: '#1890FF',

  warehouseCardBackgroundHover: '#F2F8FD',
  warehouseCardBorderHover: '1px solid rgba(0, 120, 212, 0.10)',
  warehouseCardBackground: '#FFFFFF',
  warehouseCardBorder: '1px solid #eeeeee',

  defaultIconColor: 'rgba(33, 33, 33, 1)',
  warningIconColor: 'rgba(228, 156, 0, 1)',
  successIconColor: 'rgba(33, 163, 102, 1)',
  infoIconColor: 'rgba(0, 120, 212, 1)',
  errorIconColor: 'rgba(255, 0, 0, 1)',
  secondaryIconColor: 'rgba(153, 153, 153, 1)',

  defaultTextColor: 'rgba(33, 33, 33, 1)',
  warningTextColor: 'rgba(228, 156, 0, 1)',
  successTextColor: 'rgba(33, 163, 102, 1)',
  infoTextColor: 'rgba(0, 120, 212, 1)',
  errorTextColor: 'rgba(255, 0, 0, 1)',
  secondaryTextColor: 'rgba(153, 153, 153, 1)',

  contentMainTitleColor: '#212121',
  contentMainDescriptionColor: '#000000',

  linkTitleColor: '#0078D4',

  tableLabelColor: '#6E6E6E',
  tableValueColor: '#212121',
  pageHeaderBackground: '#F3F3F3',
  pageHeaderTitleColor: '#004578',
  pageHeaderTitleFontSize: '28px',
  pageHeaderTitleFontWeight: '700',
  pageHeaderTitleLineHeight: 'normal',
  pageHeaderTitleFontFamily: 'Roboto',
  pageHeaderSubtitleColor: '#212121',
  pageHeaderSubtitleFontSize: '14px',
  pageHeaderSubtitleFontWeight: '400',
  pageHeaderSubtitleLineHeight: 'normal',
  pageHeaderSubtitleFontFamily: 'Roboto',
  pageHeaderSubtitleFontStyle: 'normal',

  formHeaderTitleColor: '#212121',
  formHeaderSubtitleColor: '#212121',
  mainIconColor: '#212121',

  scrollBarThumb: '#1890FF',
  scrollBarBackground: 'rgba(242, 248, 253, 0.2)',
  mainPageActiveShortcutButtonBackground: '#1890FF',
  mainPageActiveShortcutButtonText: '#fff',

  mainPageInactiveShortcutButtonBackground: 'rgba(255, 255, 255, 0.10)',
  mainPageInactiveShortcutButtonText: '#b4b4b4',

  tabContainerBackground: '#1890FF',
  tabBackground: 'rgba(0, 120, 212, 0.1)',
  tabText: '#ffffff',
  tabIcon: '#ffffff',
  tabSelectedBackground: '#ffffff',
  tabIconSelected: '#1890FF',
  tabSelectedText: '#1890FF',

  // Semantic surface tokens — same values as darkTheme today; kept per-theme
  // so a future classic redesign can retune them without touching consumers.
  surfaceStrong: '#0e1a2c',
  surfaceSoft: '#f6f7fb',
  surfaceSofter: '#fafbfd',
  textOnSurface: '#0f172a',
  textMuted: '#6b7280',
  borderSubtle: '#e4e7ee',
  borderStrong: '#cdd3df',
  accentLink: '#1976e2',
  statePositive: '#14a45b',
  stateWarning: '#ef8a17',
  stateCritical: '#e53935',
  stateInfo: '#2272d6',
  textOnSurfaceSecondary: '#334155',
  textMutedSoft: '#94a3b8',
  surfaceMuted: '#f8fafc',

  // Status tint backgrounds (primaryTint follows the classic primary #1890FF)
  warningTint: '#e49c0026',
  successTint: '#21a36626',
  infoTint: '#0078d426',
  primaryTint: '#1890ff0a',

  // Accounting category identity palette — identical to darkTheme by design
  // (data-identity colors must not shift meaning on theme switch).
  categoryIncomeProduction: '#1b8a4d',
  categoryIncomeProductionTint: '#1b8a4d1a',
  categoryIncomeService: '#2272d6',
  categoryIncomeServiceTint: '#2272d61a',
  categoryIncomeOther: '#9b6bd1',
  categoryIncomeOtherTint: '#9b6bd11a',
  categoryIncomeLoan: '#d9a635',
  categoryIncomeLoanTint: '#d9a6351a',
  categoryExpenseMaterial: '#d9533a',
  categoryExpenseMaterialTint: '#d9533a1a',
  categoryExpenseTransport: '#ef8a17',
  categoryExpenseTransportTint: '#ef8a171a',
  categoryExpenseSalary: '#b85ec7',
  categoryExpenseSalaryTint: '#b85ec71a',
  categoryExpenseUtility: '#1f7ad1',
  categoryExpenseUtilityTint: '#1f7ad11a',
  categoryExpenseRent: '#5a6b88',
  categoryExpenseRentTint: '#5a6b881a',
  categoryExpenseTax: '#0e1a2c',
  categoryExpenseTaxTint: '#0e1a2c1a',
  categoryExpenseOther: '#94a3b8',
  categoryExpenseOtherTint: '#94a3b81a',
}
